import { IToastConfig } from 'src/common/primitives/Toast';

export function generateSuccessToast(id: number): IToastConfig {
  return {
    id,
    title: `Success`,
    description: 'The organization settings have been updated.',
    type: 'success',
  };
}
